export default __webpack_public_path__ + "static/contact-1287ccea2734d740744a1ac4f1afc8b7.jpg";